module.exports = __webpack_public_path__ + "static/media/hospital.60187139.webp";